
import { OrderTypeEnums } from "src/app/enum/order-enums";
import { QuotationStateEnums } from "src/app/enum/quotation-enums";

export class QuotationModel {
  quotationId: number = 0;
  branchId: number = 0;
  consecutive: number = 0;
  dateQuotation: Date = new Date;
  dateExpiration: Date = new Date;
  quotationTypeId: number = OrderTypeEnums.rental;
  clientId: number | null = null;
  nameClient: string = "";
  constructionSiteId: number | null = null;
  nameConstructionSite: string | null = null;
  contact: string | null = null;
  phone1: string | null = null;
  phone2: string | null = null;
  addressConstructionSite: string | null = null;
  email: string | null = null;
  priceListId: number | null = null;
  sellerId: number = 0;
  observation: string | null = null;
  conceptIdTypeBussiness1: number = 0;
  conceptIdTypeBussiness2: number = 0;
  paymentMethod: string | null = null;
  deliveryTime: string | null = null;
  conceptIdTypeEquipment: number = 0;
  mountingValue: number = 0;
  quotationStateId: number = QuotationStateEnums.open;
  swConditions: boolean = true;
  observationCommercial: string | null = null;
  conceptIdConceptRejection: number | null = null;
  observationRejection: string | null = null;
  showConsolidatedEquipmentAvailability: boolean = false;
  createDate: Date = new Date;
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}